import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { Document, Page, pdfjs } from 'react-pdf'; 
import styles from "./DocumentDisplay.module.scss";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export const DocumentDisplay = ({base64Data, closeViewer, fileName}) => {
    const [pageNumber, setPageNumber] = useState<number>(1)
    const [numPages, setNumPages] = useState<number>(null);
    const [tempPageNum, setTempPageNum] = useState<number>(pageNumber);
    const [scale, setScale] = useState(1.25);
    
    const pdfData = base64Data?.startsWith('data:') || base64Data?.startsWith('blob:')
        ? base64Data 
        : `data:application/pdf;base64,${base64Data}`;
    
    function onDocumentLoadSuccess({numPages}) {
        setNumPages(numPages);
        setPageNumber(1);
    }

    function onDocumentLoadError(error) {
        console.error('Error loading PDF:', error);
    }

    function changePage(offset) {
        setPageNumber(pageNumber => pageNumber + offset);
    }

    function nextPage() {
        changePage(1);
    }

    function previousPage() {
        changePage(-1);
    }

    function zoomIn() {
        setScale(prev => Math.min(prev+0.2, 2))
    }

    function zoomOut() {
        setScale(prev => Math.max(prev-0.2, 0.7))
    }

    function handlePageChange() {
        if (Number.isNaN(tempPageNum)) {
            setPageNumber(1);
            setTempPageNum(1);
        } else if (tempPageNum > numPages) {
            setPageNumber(numPages);
            setTempPageNum(numPages);
        } else if (tempPageNum < 1) {
            setPageNumber(1);
            setTempPageNum(1);
        } else {
            setPageNumber(tempPageNum);
        }
    }

    function handleInputChange(e){
        const value = e.target.value;

        if (value === "") {
            setTempPageNum(NaN);
            return;
        }
        
        const parsed = parseInt(value);
        if (!Number.isNaN(parsed)) {
            setTempPageNum(parsed);
        }
    }

    useEffect(() => {
        setTempPageNum(pageNumber)
    },[pageNumber, pdfData])


    return (
        <div className={styles.previewer}>
            <div className={styles.header}>
                <span className={styles.docTitle}>{fileName}</span>
                <Button className={styles.CloseButton} variant="primary" onClick={() => closeViewer()}><i className="fa-solid fa-xmark-large"></i></Button>
            </div>
            <Document onLoadError={onDocumentLoadError} file={pdfData} onLoadSuccess={onDocumentLoadSuccess} >
                <Page pageNumber={pageNumber} scale={scale}/>
            </Document>
            <div className={styles.toolbar}>
                <div>
                    <span className={styles.pageCount}>Page </span>
                    <input className ={`${styles.pageInput}` } type="text" inputMode="numeric" value={tempPageNum === null || (Number.isNaN(tempPageNum))? "" :tempPageNum} onChange={handleInputChange} onKeyDown={(e) => {if (e.key === "Enter") handlePageChange();}} onBlur={handlePageChange}></input>
                    <span className={styles.pageCountTotal}> / {numPages}</span>
                </div>
                
                <span className={styles.pageCount}>|</span>
                <Button variant="primary" disabled={pageNumber <= 1} onClick={previousPage}><i className="fa-solid fa-arrow-left"></i></Button>
                <Button variant="primary" disabled={pageNumber >= numPages} onClick={nextPage}><i className="fa-solid fa-arrow-right"></i></Button>
                <span className={styles.pageCount}>|</span>
                <Button variant="primary" onClick={zoomOut}><i className="fa-solid fa-magnifying-glass-minus"></i></Button>
                <Button variant="primary" onClick={zoomIn}><i className="fa-solid fa-magnifying-glass-plus"></i></Button>
            </div>
        </div>
    )
}